export class ExpenseDomain {
  static SPOTEXPENSE: string = "spotexpense";
  static SPOTEXPENSETABLE: string = "spotexpenses";
  static SALARY: string = "employeesalaries";
  static PREVIRED: string = "previred";
  static RUTPREVIRED: string = "96.929.390-0";
  static ADVANCE: string = "advance";
  static SALARYFRONT: string = "salary";
  static OTHER: string = "other";
  static CAPITALINJECTION:string = "capitalinjection";
  static INTEREST:string = "interest";
  static MUTUALFUND:string = "mutualfund";
  static ASSETSALE:string = "assetsale";
  static INSURANCE:string = "insurance";
  static COMPENSATION:string = "compensation";
  static SUBSIDIES:string = "subsidies";
  static OTHERINCOME:string = "otherincome";
  static SIIF22: string = "siitaxf22";
  static SIIF29: string = "siitaxf29";
  static SIITAXLAND: string = "siitaxland";
  static RUTSII: string = "60803000-K";

static INFLOWS: string[] = [
    ExpenseDomain.INTEREST,
    ExpenseDomain.MUTUALFUND,
    ExpenseDomain.INSURANCE,
    ExpenseDomain.SUBSIDIES,
    ExpenseDomain.CAPITALINJECTION, 
    ExpenseDomain.ASSETSALE, 
    ExpenseDomain.COMPENSATION,
    ExpenseDomain.OTHERINCOME
  ];

static OUTFLOWS: string[] = [
    ExpenseDomain.SPOTEXPENSE,
    ExpenseDomain.SALARYFRONT,
    ExpenseDomain.SALARY,
    ExpenseDomain.PREVIRED,
    ExpenseDomain.ADVANCE,
    ExpenseDomain.OTHER,
    ExpenseDomain.SIIF22,
  ExpenseDomain.SIIF29,
  ];

}